var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25059 16.6514L15.7506 9.15137M11.7276 3.15137L14.3796 4.74137L17.4591 5.01287L18.6696 7.85837L21.0006 9.88637L20.3076 12.9014L21.0006 15.9149L18.6696 17.9444L17.4591 20.7899L14.3796 21.0614L11.7276 22.6514L9.07709 21.0614L5.99609 20.7899L4.78709 17.9444L2.45459 15.9149L3.14759 12.9014L2.45459 9.88787L4.78709 7.85837L5.99609 5.01287L9.07709 4.74137L11.7276 3.15137ZM10.5006 10.6514C10.5006 11.0492 10.3426 11.4307 10.0612 11.712C9.77994 11.9933 9.39841 12.1514 9.00059 12.1514C8.60276 12.1514 8.22123 11.9933 7.93993 11.712C7.65862 11.4307 7.50059 11.0492 7.50059 10.6514C7.50059 10.2535 7.65862 9.87201 7.93993 9.59071C8.22123 9.3094 8.60276 9.15137 9.00059 9.15137C9.39841 9.15137 9.77994 9.3094 10.0612 9.59071C10.3426 9.87201 10.5006 10.2535 10.5006 10.6514ZM16.5006 15.9014C16.5006 16.2992 16.3426 16.6807 16.0612 16.962C15.7799 17.2433 15.3984 17.4014 15.0006 17.4014C14.6028 17.4014 14.2212 17.2433 13.9399 16.962C13.6586 16.6807 13.5006 16.2992 13.5006 15.9014C13.5006 15.5035 13.6586 15.122 13.9399 14.8407C14.2212 14.5594 14.6028 14.4014 15.0006 14.4014C15.3984 14.4014 15.7799 14.5594 16.0612 14.8407C16.3426 15.122 16.5006 15.5035 16.5006 15.9014Z",
    stroke: "#71839B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanners);
export default __webpack_public_path__ + "static/media/banners.85c9ca4e67f780f764344ddee7285ec4.svg";
export { ForwardRef as ReactComponent };